import { FC } from 'react';
import { StyledIcon } from './styles';
import type { IconAdornmentProps } from './types';

const IconAdornment: FC<IconAdornmentProps> = (props) => {
  return <StyledIcon color={null} {...props} />;
};

export default IconAdornment;
